
import { ChangeEventHandler, type JSX } from "react";
import { V3RadioButton } from "../OptionInput"
import { V3Caption } from "../Typography"
import { VerticalSpacing } from "../VerticalSpacing"
import { V3ECORadioWrapper, V3ECOWrapper } from "./V3EmbedColorOption.styles"

interface V3EmbedColorOptionProps {
    label: string,
    name: string,
    onChange: ChangeEventHandler,
    checked: boolean,
    value: string,
    svg: JSX.Element
}

export const V3EmbedColorOption = ({ label, name, checked, onChange, value, svg }: V3EmbedColorOptionProps) => {
    return <label htmlFor={value}>
        <V3ECOWrapper $active={checked}>
            <V3ECORadioWrapper>
                <div>
                    <V3Caption><strong>{label}</strong></V3Caption>
                </div>
                <div>
                    <V3RadioButton
                        name={name}
                        id={value}
                        value={value}
                        checked={checked}
                        onChange={onChange}
                    />
                </div>
            </V3ECORadioWrapper>
            <VerticalSpacing top={12}>
                {svg}
            </VerticalSpacing>
        </V3ECOWrapper >
    </label>
}